import { gemini } from './gemini';
import { byteplus } from './byteplus';
import { openai } from './openai';
import { xai } from './xai';
import { anthropic } from './anthropic';
import { elevenlabs } from './elevenlabs';
import { meshy } from './meshy';
import type { ProviderAdapter, ModelDescriptor } from '../router/types';
import type { Provider } from '../lib/db';

// Uniblock is a data-fetch BYOK provider (on-chain crypto data), not a
// generative model adapter. We register a no-models adapter so the existing
// PROVIDERS map stays exhaustively typed; live calls go through
// `uniblockCall()` in ./uniblock.ts instead of `.generate()`.
const uniblock: ProviderAdapter = {
  id: 'uniblock',
  models: [],
  async generate() {
    throw new Error('Uniblock is a data provider, not a generation model.');
  },
};

export const PROVIDERS: Record<Provider, ProviderAdapter> = { gemini, byteplus, openai, xai, anthropic, elevenlabs, meshy, uniblock };

export const ALL_MODELS: (ModelDescriptor & { provider: Provider })[] = (
  Object.values(PROVIDERS).flatMap(p => p.models.map(m => ({ ...m, provider: p.id })))
);

export function modelById(id: string) {
  return ALL_MODELS.find(m => m.id === id);
}